// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DS {
  display: flex;
  margin: 0;
  background-color: var(--rm-bg);
}
.DS .body {
  display: flex;
  width: 100%;
}
.DS .body .sidebar {
  background-color: var(--rm-surface);
  border-right: 1px solid var(--rm-border);
  height: 87vh;
  flex: 1 1;
  display: flex;
  margin: 0;
  overflow: auto;
  min-width: 210px;
  box-shadow: 1px 0 4px rgba(0, 0, 0, 0.04);
}
.DS .body .sidebar ul {
  padding: 12px 14px;
  width: 100%;
  margin: 0;
}
.DS .body .sidebar li {
  font-weight: 600;
  font-size: 13px;
  margin: 4px 0 0 0;
  list-style: none;
  display: flex;
  align-items: center;
  border-radius: var(--rm-radius);
  padding: 9px 12px;
  color: var(--rm-text-muted);
  background-color: transparent;
  min-width: 0;
  border: 1px solid transparent;
  transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition);
  cursor: pointer;
}
.DS .body .sidebar li svg {
  font-size: 18px;
  margin-right: 8px;
  color: var(--rm-text-muted);
  flex-shrink: 0;
  transition: color var(--rm-transition);
}
.DS .body .sidebar li:hover {
  color: var(--rm-primary);
  background-color: var(--rm-primary-dim);
  border-color: transparent;
}
.DS .body .sidebar li:hover svg {
  color: var(--rm-primary);
}
.DS .body .sidebar li.active {
  color: var(--rm-primary);
  background-color: var(--rm-primary-dim);
  border-color: var(--rm-primary-border);
  font-weight: 700;
}
.DS .body .sidebar li.active svg {
  color: var(--rm-primary);
}
.DS .body .resizable_app .pointer-events-none {
  pointer-events: none;
}
.DS .body .resizable_app .assets {
  background-color: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius-lg);
  height: 87vh;
  margin: 8px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
}
.DS .body .resizable_app .contracts {
  background-color: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius-lg);
  height: 87vh;
  flex: 5 1;
  margin: 8px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
}
.DS .body .resizable_app .policies {
  height: 87vh;
  background-color: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius-lg);
  flex: 10 1;
  min-width: 350px;
  margin: 8px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
}
.DS .body .datatransfer {
  background-color: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius-lg);
  flex: 10 1;
  height: 87vh;
  margin: 8px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
}
.DS .body .datatransfer .rotate {
  animation: rotation 2s infinite linear;
  width: 45px;
  height: 105px;
  margin-top: 5px;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.DS .body .details {
  height: 87vh;
  background-color: var(--rm-surface);
  border: 1px solid var(--rm-border);
  border-radius: var(--rm-radius-lg);
  flex: 2 1;
  margin: 8px;
  overflow: auto;
  box-shadow: var(--rm-shadow-sm);
  min-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/DataSpaceSimple.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,8BAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;AACR;AACQ;EACI,mCAAA;EACA,wCAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;AACZ;AACY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAChB;AAEY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,gHAAA;EACA,eAAA;AAAhB;AAEgB;EACI,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,sCAAA;AAApB;AAIY;EACI,wBAAA;EACA,uCAAA;EACA,yBAAA;AAFhB;AAIgB;EACI,wBAAA;AAFpB;AAMY;EACI,wBAAA;EACA,uCAAA;EACA,sCAAA;EACA,gBAAA;AAJhB;AAMgB;EACI,wBAAA;AAJpB;AAUY;EACI,oBAAA;AARhB;AAWY;EACI,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;AAThB;AAYY;EACI,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;AAVhB;AAaY;EACI,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;AAXhB;AAeQ;EACI,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;AAbZ;AAeY;EACI,sCAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AAbhB;AAgBY;EACI;IAAO,uBAAA;EAbrB;EAcc;IAAO,yBAAA;EAXrB;AACF;AAcQ;EACI,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;AAZZ","sourcesContent":[".DS {\r\n    display: flex;\r\n    margin: 0;\r\n    background-color: var(--rm-bg);\r\n\r\n    .body {\r\n        display: flex;\r\n        width: 100%;\r\n\r\n        .sidebar {\r\n            background-color: var(--rm-surface);\r\n            border-right: 1px solid var(--rm-border);\r\n            height: 87vh;\r\n            flex: 1;\r\n            display: flex;\r\n            margin: 0;\r\n            overflow: auto;\r\n            min-width: 210px;\r\n            box-shadow: 1px 0 4px rgba(0, 0, 0, 0.04);\r\n\r\n            ul {\r\n                padding: 12px 14px;\r\n                width: 100%;\r\n                margin: 0;\r\n            }\r\n\r\n            li {\r\n                font-weight: 600;\r\n                font-size: 13px;\r\n                margin: 4px 0 0 0;\r\n                list-style: none;\r\n                display: flex;\r\n                align-items: center;\r\n                border-radius: var(--rm-radius);\r\n                padding: 9px 12px;\r\n                color: var(--rm-text-muted);\r\n                background-color: transparent;\r\n                min-width: 0;\r\n                border: 1px solid transparent;\r\n                transition: background-color var(--rm-transition), color var(--rm-transition), border-color var(--rm-transition);\r\n                cursor: pointer;\r\n\r\n                svg {\r\n                    font-size: 18px;\r\n                    margin-right: 8px;\r\n                    color: var(--rm-text-muted);\r\n                    flex-shrink: 0;\r\n                    transition: color var(--rm-transition);\r\n                }\r\n            }\r\n\r\n            li:hover {\r\n                color: var(--rm-primary);\r\n                background-color: var(--rm-primary-dim);\r\n                border-color: transparent;\r\n\r\n                svg {\r\n                    color: var(--rm-primary);\r\n                }\r\n            }\r\n\r\n            li.active {\r\n                color: var(--rm-primary);\r\n                background-color: var(--rm-primary-dim);\r\n                border-color: var(--rm-primary-border);\r\n                font-weight: 700;\r\n\r\n                svg {\r\n                    color: var(--rm-primary);\r\n                }\r\n            }\r\n        }\r\n\r\n        .resizable_app {\r\n            .pointer-events-none {\r\n                pointer-events: none;\r\n            }\r\n\r\n            .assets {\r\n                background-color: var(--rm-surface);\r\n                border: 1px solid var(--rm-border);\r\n                border-radius: var(--rm-radius-lg);\r\n                height: 87vh;\r\n                margin: 8px;\r\n                overflow: auto;\r\n                box-shadow: var(--rm-shadow-sm);\r\n            }\r\n\r\n            .contracts {\r\n                background-color: var(--rm-surface);\r\n                border: 1px solid var(--rm-border);\r\n                border-radius: var(--rm-radius-lg);\r\n                height: 87vh;\r\n                flex: 5;\r\n                margin: 8px;\r\n                overflow: auto;\r\n                box-shadow: var(--rm-shadow-sm);\r\n            }\r\n\r\n            .policies {\r\n                height: 87vh;\r\n                background-color: var(--rm-surface);\r\n                border: 1px solid var(--rm-border);\r\n                border-radius: var(--rm-radius-lg);\r\n                flex: 10;\r\n                min-width: 350px;\r\n                margin: 8px;\r\n                overflow: auto;\r\n                box-shadow: var(--rm-shadow-sm);\r\n            }\r\n        }\r\n\r\n        .datatransfer {\r\n            background-color: var(--rm-surface);\r\n            border: 1px solid var(--rm-border);\r\n            border-radius: var(--rm-radius-lg);\r\n            flex: 10;\r\n            height: 87vh;\r\n            margin: 8px;\r\n            overflow: auto;\r\n            box-shadow: var(--rm-shadow-sm);\r\n\r\n            .rotate {\r\n                animation: rotation 2s infinite linear;\r\n                width: 45px;\r\n                height: 105px;\r\n                margin-top: 5px;\r\n            }\r\n\r\n            @keyframes rotation {\r\n                from { transform: rotate(0deg); }\r\n                to   { transform: rotate(359deg); }\r\n            }\r\n        }\r\n\r\n        .details {\r\n            height: 87vh;\r\n            background-color: var(--rm-surface);\r\n            border: 1px solid var(--rm-border);\r\n            border-radius: var(--rm-radius-lg);\r\n            flex: 2;\r\n            margin: 8px;\r\n            overflow: auto;\r\n            box-shadow: var(--rm-shadow-sm);\r\n            min-width: 200px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
